import { render, staticRenderFns } from "./boxicons.vue?vue&type=template&id=5bc97254&"
import script from "./boxicons.vue?vue&type=script&lang=js&"
export * from "./boxicons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports